namespace $.$$ {
	$mol_style_define( $shm_projects_digest_view, {
		Head: { justifyContent: 'flex-start' },
		Notes: {
			Scope: {
				font: { size: '.75rem' },
				color: $mol_theme.shade,
			},
		},
	} )
}
